import { classes, style } from 'typestyle'

import { Box } from '../../../../__aeki__/components/box/box.component'
import { Line } from '../../../../__aeki__/components/line'
import { Text } from '../../../../__aeki__/components/text/text.component'

import { paddingVerticalOuter } from '../../../../__aeki__/styles/default/padding'
import { f17i } from '../../../../__aeki__/styles/styleset/font-size/f17i'
import { pb12 } from '../../../../__aeki__/styles/styleset/padding/pb12'
import { pt12 } from '../../../../__aeki__/styles/styleset/padding/pt12'

export const Info = (props: any) => {
  const {
    children,
    maxWidth,
    label,
    labelWidth = 60,
    icon = 'info',
    disableUpperLine,
    type,
  } = props

  let background = '#f6f8ff'

  if (type) {
    if (type === 'warning') {
      background = '#fffded'
    } else if (type === 'error') {
      background = '#ffeded'
    }
  }

  return (
    <Box row fullWidth>
      {!disableUpperLine && <Line />}
      <Box baseline="none" className={classes(pt12, pb12, style({ background }))} flex spaceBetween>
        <Box
          className={classes(paddingVerticalOuter)}
          baseline="none"
          maxWidth={maxWidth}
          flex
          centerAutoX
          fullWidth
        >
          <Box baseline="none" minWidth={24} flex alignCenterY>
            <span className={classes('material-icons-two-tone', f17i)}>{icon}</span>
          </Box>
          <Box baseline="none" minWidth={labelWidth} flex alignCenterY>
            <Text size="sm" semiBold>
              {label}
            </Text>
          </Box>
          <Box baseline="none" row alignCenterY>
            {children}
          </Box>
        </Box>
      </Box>
      <Line />
    </Box>
  )
}
